import { Footer } from "../../components/Footer/Footer"
import { Header } from "../../components/Header/Header"
import AdditionalArticle from "./AdditionalArticle/AdditionalArticle"

const AdditionalArticlePage = () => {
    return (
        <>
            <Header />
            <AdditionalArticle />
            <Footer /> 
        </>
    )
}

export default AdditionalArticlePage